// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"c47fea45","324":"3c65ddda","339":"ce7a0fb2","347":"afe54231","356":"1483029e","453":"57efe4b5","763":"ec3e00ba","943":"b326dead","950":"966550c6"}[chunkId] + ".chunk.js";
};